var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Nội dung tin nhắn",
        visible: _vm.dialogVisible,
        width: "60%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "18vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "hr" }, [_c("hr")]),
      _c("div", { staticClass: "table-content row-data" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("el-input", {
              staticStyle: { "word-break": "break-word" },
              attrs: { type: "textarea", rows: 10 },
              model: {
                value: _vm.viewContent[0].sendContent,
                callback: function ($$v) {
                  _vm.$set(_vm.viewContent[0], "sendContent", $$v)
                },
                expression: "viewContent[0].sendContent",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }